export default {"src":"/_next/static/media/noimage.7dc5d3ff.svg","height":104,"width":107,"blurWidth":0,"blurHeight":0};